// extracted by css-extract-rspack-plugin
var _1 = "rs";
var _2 = "rr";
export { _1 as "scrollContent", _2 as "scrollPaginationComponent" }
